import { useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import { GenerateField } from "./GenerateField";

export function HouseField() {
  const {
    formState: { errors },
  } = useFormContext();

  const fieldName = "house";
  const hasError = !!errors[fieldName]?.type;

  return (
    <GenerateField
      errorText="Required field"
      name={fieldName}
      rules={{
        validate: (value) => !!value?.trim(),
      }}
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          error={hasError}
          label="House"
          variant="filled"
          inputProps={{
            maxLength: 200,
          }}
        />
      )}
    />
  );
}
